import { useController } from 'react-hook-form';
import { Toggle, ToggleProps } from 'ui/toggle';
import { FieldProps } from './types';

type ToggleFieldProps = FieldProps & Omit<ToggleProps, 'onClick' | 'isActive'>;

export const ToggleField = ({ name, ...rest }: ToggleFieldProps) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    defaultValue: '',
  });

  return <Toggle {...rest} isActive={value} onClick={onChange} />;
};
